import React from "react";
import { GlobalRoutes } from "../../../GlobalRouter/Routes";
import DescriptionIcon from "@mui/icons-material/Description";
import classes from "./FAQLink.module.css";

const FAQLink = () => {
    return (
        <a
            className={classes.FAQlink}
            href={GlobalRoutes.FAQ.path}
            alt="FAQ Help"
            target="_blank"
            rel="noopener noreferrer"
        >
            <DescriptionIcon /> FAQ
        </a>
    );
};

export default FAQLink;
